/**
 * Region/State/Province data for countries that require state selection.
 *
 * Used in location settings and forms where users need to select their
 * state or province within a country.
 */

// US States
export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
] as const;

// UK Regions/Countries
export const UK_REGIONS = [
  "England",
  "Scotland",
  "Wales",
  "Northern Ireland",
] as const;

// Canadian Provinces and Territories
export const CA_PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
] as const;

// Australian States and Territories
export const AU_STATES = [
  "Australian Capital Territory",
  "New South Wales",
  "Northern Territory",
  "Queensland",
  "South Australia",
  "Tasmania",
  "Victoria",
  "Western Australia",
] as const;

/**
 * Map of country codes to their regions/states/provinces.
 */
export const REGIONS_BY_COUNTRY: Record<string, readonly string[]> = {
  US: US_STATES,
  GB: UK_REGIONS,
  CA: CA_PROVINCES,
  AU: AU_STATES,
};

/**
 * Gets the regions/states/provinces for a given country code.
 *
 * @param countryCode - ISO 3166-1 alpha-2 country code (e.g., "US", "GB")
 * @returns Array of region names, or empty array if country has no predefined regions
 *
 * @example
 * getRegionsForCountry("US") // Returns US states
 * getRegionsForCountry("GB") // Returns UK regions
 * getRegionsForCountry("FR") // Returns [] (no predefined regions)
 */
export function getRegionsForCountry(countryCode: string): readonly string[] {
  return REGIONS_BY_COUNTRY[countryCode.toUpperCase()] ?? [];
}
